import { render, staticRenderFns } from "./VxDateRangePicker.vue?vue&type=template&id=0c98ffe4&"
import script from "./VxDateRangePicker.vue?vue&type=script&lang=js&"
export * from "./VxDateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./VxDateRangePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports